import PropTypes from 'prop-types';

const MoldPropType = PropTypes.exact({
  brand: PropTypes.string.isRequired,
  cavityCount: PropTypes.number.isRequired,
  cavityVolume: PropTypes.number.isRequired,
  dimensions: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  normalizedTitle: PropTypes.string,
  isSelected: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

const MoldsPropType = PropTypes.arrayOf(MoldPropType);

export { MoldsPropType, MoldPropType };
